// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.add-purchase h1 {
  text-align: center;
}

.add-purchase form {
  display: flex;
  flex-direction: column;
}

.custom-field-group {
  display: block;
  align-items: center;
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/pages/AddOrEditPurchase.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,WAAW;AACb","sourcesContent":[".add-purchase h1 {\n  text-align: center;\n}\n\n.add-purchase form {\n  display: flex;\n  flex-direction: column;\n}\n\n.custom-field-group {\n  display: block;\n  align-items: center;\n  width: 100%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
